<template>
  <transition
    :name="transition"
    mode="in-out"
    appear
    :appear-active-class="enterClass"
    :enter-active-class="enterClass"
    :leave-active-class="leaveClass"
    @beforeEnter="beforeEnter"
    @afterLeave="afterLeave"
  >
    <div v-if="show">
      <div class="modal-background" @click="deactive"></div>
      <div class="modal-card" :style="style">
        <div class="modal-card-rap">
          <section class="modal-card-body">
            <slot name="body"></slot>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import BaseModal from '@/lib/BaseModal';
export default {
  mixins: [BaseModal],
  name: 'CardModal',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // props
  // ===========================================================================
  props: {
    height: {
      type: String,
    },
    title: {
      type: String,
    },
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    style () {
      return {
        // 'margin-top': `calc(50% - ${this.height}/2 - 45px)`,
      };
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    ok () {
      this.$emit('ok');
    },

    cancel () {
      this.$emit('cancel');
    },
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.modal-card {
  margin: inherit;
  .modal-card-body {
    // height: 100vh;
    height: calc(100% - 80px);
    padding: 20px 0;
    position: absolute;
    left: 10px;
  }
  .modal-card-title {
    font-size: 28px;
    margin: 0;
  }
  .delete {
    float: right;
    width: 25px;
    height: 25px;
    background: #fefefe;
    border: #fefefe;
    margin-top: 5px;
  }
}
</style>
